import { getGlobalStates } from "userful-chronos-app-common-js/dist/globalstates/globalStates";

import {
    REQUEST_ADD_PASSPORT,
    REQUEST_LIST_PASSPORTS,
    REQUEST_REMOVE_PASSPORT,
    REQUEST_UPDATE_PASSPORT,
    REQUEST_LIST_DASHBOARDS,
} from "userful-chronos-app-common-js/dist/message/messageTypeDefinitions/integration/grafanaMsgDefinitions";
import {
    GrafanaPassportHeader,
    GrafanaPassportID,
} from "userful-chronos-app-common-js/dist/models/integration/grafana";
import "./grafanaMsgReciever";

export const requestListPassports = () => {
    getGlobalStates().eventBus.sendMsg(REQUEST_LIST_PASSPORTS);
};

export const requestAddPassport = (payload: GrafanaPassportHeader) => {
    getGlobalStates().eventBus.sendMsg(REQUEST_ADD_PASSPORT, payload);
};

export const requestUpdatePassport = (payload: GrafanaPassportHeader) => {
    getGlobalStates().eventBus.sendMsg(REQUEST_UPDATE_PASSPORT, payload);
};

export const requestRemovePassport = (payload: GrafanaPassportID) => {
    getGlobalStates().eventBus.sendMsg(REQUEST_REMOVE_PASSPORT, payload);
};

export const requestListDashboards = (payload: GrafanaPassportID) => {
    getGlobalStates().eventBus.sendMsg(REQUEST_LIST_DASHBOARDS, payload);
};
